<template>
  <v-container v-if="isShare" fluid>
    <v-row> </v-row>
    <v-row class="mb-4">
      <v-col class="py-0 pl-0 mt-8 d-flex align-items-center">
        <span class="pt-3">
          <v-icon
            style="cursor: pointer; width: 12px"
            @click="closeHandler()"
            size="36"
            >mdi-arrow-left</v-icon
          >
        </span>
        <span class="h3 pt-4 pl-3 shared-data-people">
          Select people you want to share with
        </span>
      </v-col>
      <v-col class="py-0 pr-0 mt-12">
        <v-text-field
          class="searchField"
          v-model="attendeeSearchField"
          solo
          hide-details
          prepend-inner-icon="search"
          label="Search User"
          clearable
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-list class="share-people" style="width: 100%">
        <!-- <v-checkbox
          @click="selectAllClicked()"
          label="Select All"
          v-model="selectAll"
          class="mt-0"
        > -->
        <!-- <template #label> -->
        <p
          class="pt-1 pb-4"
          style="font-size: 1.125rem; font-weight: 400; color: #848484"
        >
          Select up to 5 attendees to share at a time
        </p>
        <!-- </template>
        </v-checkbox> -->
        <v-list-item v-for="(item, index) in attendeeList" :key="index">
          <v-checkbox
            class="checkBoxBriefcase mt-0 py-3"
            v-model="selected"
            multiple
            :value="item"
          >
            <template #label>
              <v-avatar size="80px" v-if="item.ProfilePictureURL">
                <v-img :src="item.ProfilePictureURL" />
              </v-avatar>
              <v-avatar size="80px" color="grey" v-else
                ><span
                  style="display: inline-block; font-size: 2rem; color: #fff"
                  >{{ getInitials(item.title) }}</span
                ></v-avatar
              >
              <span class="pt-1 pl-3">{{ item.title }}</span>
            </template>
          </v-checkbox>
        </v-list-item>
      </v-list>
    </v-row>
    <div style="position: absolute; right: 50px; bottom: 50px">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="shareData()"
            normal
            color="success"
            style="background-color: #19a883"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon size="30" class="mr-2" color="#fff">share</v-icon>
            <span style="font-size: 16px">Share</span>
          </v-btn>
        </template>
        <span>Share</span>
      </v-tooltip>
    </div>
  </v-container>
  <v-container v-else fluid>
    <v-row
      style="
        font-size: 24px;
        font-weight: 700;
        color: #333;
        text-transform: uppercase;
      "
      class="h1 pb-4 mt-3"
      >Virtual Briefcase</v-row
    >
    <v-row dense class="" style="margin: 0 -15px">
      <v-col class="mob_full_width">
        <span style="font-weight: bold; font-size: 20px"
          >{{ briefCaseObjects.length }} &nbsp;items</span
        ></v-col
      >
      <v-col class="mob_full_width">
        <v-row>
          <v-col cols="8" class="py-0 pr-0">
            <v-text-field
              class="searchField"
              v-model="searchField"
              solo
              hide-details
              prepend-inner-icon="search"
              label="Search Items"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="py-0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  height="48"
                  color="#cbcbcb"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="filter-butn btn"
                >
                  <v-icon color="black">filter_list</v-icon>
                  <span class="pl-2" style="color: black"> Filter</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="filterSelected(item)"
                  style="cursor: pointer"
                  v-for="(item, index) in entityTypes"
                  :key="index"
                >
                  <v-list-item-title>{{ item.ENTITY_NAME }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-tabs slider-color="#000" v-model="tabSelection">
        <v-tab
          active-class="tab-active"
          data-analytics
          data-page-name="/briefcase"
          data-action="click"
          data-action-type="tab"
          data-action-label="ViewedMyBriefcaseTab"
          @click="getBriefcaseVals()"
          ><span style="font-size: 16px"> My Briefcase</span></v-tab
        >
        <v-tab
          active-class="tab-active"
          data-page-name="/briefcase"
          data-action="click"
          data-action-type="tab"
          data-action-label="ViewedSharedBookmarkTab"
          @click="getSharedWithMe()"
          ><span style="font-size: 16px"> Shared With Me</span></v-tab
        >
      </v-tabs>
    </v-row>
    <v-row class="pt-8 mt-8" align="center" justify="center" v-if="loader">
      <v-progress-circular
        size="80"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>

    <v-row
      align="center"
      justify="center"
      style="height: 70%"
      class="px-8"
      v-else-if="!loader && briefCaseObjects.length == 0"
    >
      <span
        class="h3"
        style="
          text-align: center;
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
        "
        v-if="tabSelection == 0 && !searchField"
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        Look for the Bookmark icon in attendees, speakers, exhibitors, resources
        and more to add to your Briefcase. Once added, you can view and access
        all your bookmarks here</span
      >
      <span
        class="h3"
        style="
          text-align: center;
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
        "
        v-else-if="tabSelection == 0 && searchField"
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        No Bookmarks Found</span
      >
      <span
        class="h3"
        style="
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
          text-align: center;
        "
        v-else
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        You have no shared bookmarks
      </span>
    </v-row>
    <v-row
      v-else
      style="border-top: 1px solid #cbcbcb; cursor: pointer"
      class="py-2 single-briefcase-list"
      @click="routeToPath(object)"
      v-for="(object, i) in briefCaseObjects"
      :key="i"
    >
      <v-col cols="1" class="py-0 pl-0">
        <v-avatar size="80" v-if="object.entityImage">
          <v-img :src="object.entityImage" class="exhibit-image" @error="object.entityImage = ''"></v-img>
        </v-avatar>
        <span class="name-initial-wrap" v-else>{{
          getInitials(object.entityName)
        }}</span>
      </v-col>
      <v-col
        cols="9"
        class="py-0 pr-0"
        style="display: flex; align-items: center; justify-content: flex-start"
      >
        <span class="h5 m-0 shared-file-name" style="font-weight: 600">
          {{ object.entityName }}
        </span>
      </v-col>
      <v-col
        class="py-0"
        cols="2"
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <div class="pr-3">
          <v-btn
            class="btn"
            v-if="!object.isShared"
            color="primary"
            @click.stop="initiateShare(object)"
          >
            <v-icon>share</v-icon>
            <span class="pl-3"> Share</span></v-btn
          >
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-avatar v-on="on" v-bind="attrs" v-if="object.senderPhotoUrl">
                  <v-img :src="object.senderPhotoUrl" @error="object.senderPhotoUrl = ''"/>
                </v-avatar>
                <v-avatar v-on="on" v-bind="attrs" color="grey" v-else>{{
                  getInitials(object.senderName)
                }}</v-avatar>
              </template>
              <span>Shared by {{ object.senderName }}</span>
            </v-tooltip>
          </div>
        </div>
        <span>
          <v-icon
            class="btn"
            v-if="!object.isShared"
            @click.stop="deleteBriefcase(object)"
            style="cursor: pointer"
            >delete</v-icon
          >
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import db from "@/components/firebaseInit";
var sharedWithMe;

var self;
export default {
  data() {
    return {
      tabSelection: null,
      attendeeSearchField: "",
      isShare: false,
      currentBookmark: {},
      selectAll: false,
      loader: false,
      selected: [],
      entityTypes: [],
      briefCaseObjects: [],
      briefCaseObjectsOriginal: [],
      APIs: APIs,
      searchField: "",
      attendeeList: [],
      originalAttendeeList: [],
    };
  },
  watch: {
    selected() {
      if (this.selected.length > 5) {
        this.selected.pop();
      }
    },
    attendeeSearchField(searchText) {
      if (searchText) {
        this.attendeeList = [];
        this.$nextTick(() => {
          this.attendeeList = this.originalAttendeeList.filter((val) =>
            val.title.toLowerCase().includes(searchText.toLowerCase())
          );
        });
      } else {
        this.attendeeList = [];
        this.attendeeList = this.originalAttendeeList;
      }
      this.checked = [];
    },
    searchField(searchText) {
      if (searchText)
        this.briefCaseObjects = [
          ...this.briefCaseObjectsOriginal.filter((val) =>
            val.entityName.toLowerCase().includes(searchText.toLowerCase())
          ),
        ];
      else this.briefCaseObjects = [...this.briefCaseObjectsOriginal];
    },
  },
  mounted() {
    self = this;
    this.fetchAllAttendees();
    this.getBriefcaseVals();
    this.entityTypes = [
      { ENTITY_TYPE: "0", ENTITY_NAME: "All" },
      // { ENTITY_TYPE: "1", ENTITY_NAME: "Session" },
      { ENTITY_TYPE: "2", ENTITY_NAME: "Speaker" },
      { ENTITY_TYPE: "3", ENTITY_NAME: "Attendee" },
      { ENTITY_TYPE: "4", ENTITY_NAME: "Expo" },
      { ENTITY_TYPE: "5", ENTITY_NAME: "Sponsor" },
      { ENTITY_TYPE: "6", ENTITY_NAME: "Resource" },
      // { ENTITY_TYPE: "7", ENTITY_NAME: "Meeting" }
    ];
    self.AddEventAnalytics({
      pageName: "/briefcase",
      action: "click",
      actiontype: "tab",
      actionLabel: "ViewedMyBriefcaseTab",
    });
  },
  methods: {
    getSharedWithMe() {
      this.loader = true;
      let that = this;
      let clientId = this.$store.state.client[0].id;
      let eventId = this.$store.state.eventid;
      let attendeeId = this.$store.state.userId;
      let path = `/OA_UAT_${clientId}${eventId}/AttendeeList/Attendees/${attendeeId}/shared-with-me/`;
      if (sharedWithMe) {
        sharedWithMe();
      }
      try {
        sharedWithMe = db.collection(path).onSnapshot((querySnapshot) => {
          this.briefCaseObjects = [];
          this.briefCaseObjectsOriginal = [];
          console.log(querySnapshot.size);
          if (querySnapshot.size > 0) {
            querySnapshot.forEach((element) => {
              let data = element.data();
              data.sharedItems[0].isShared = true;
              data.sharedItems[0].senderName = data.senderName;
              data.sharedItems[0].senderPhotoUrl = data.senderPhotoUrl;
              this.briefCaseObjects.push(data.sharedItems[0]);
              this.briefCaseObjectsOriginal.push(data.sharedItems[0]);
              console.log(data);
            });
          }
          that.loader = false;
        });
      } catch (e) {
        that.loader = false;
        console.log(e);
      }
    },
    routeToPath(bookmark) {
      this.$emit("closeOnClick");
      if (bookmark.entityType == 6) {
        if (bookmark.entityMetadata.HyperLinkUrl) {
          window.open(bookmark.entityMetadata.HyperLinkUrl);
        } else if (
          bookmark.entityMetadata.ResourceType == "pdf" &&
          bookmark.entityMetadata.ResourcePath
        ) {
          window.open(bookmark.entityMetadata.ResourcePath);
        } else {
          window.open(bookmark.entityMetadata.ResourcePath);
        }
      } else if (bookmark.entityLink) {
        if (bookmark.entityType == this.entityTypes[4].ENTITY_TYPE) {
          this.$store.commit("addSponsorID", bookmark.entityId);
          this.$router.replace({
            path: bookmark.entityLink,
            params: { sid: bookmark.entityId },
            query: {
              sid: bookmark.entityId,
            },
          });
        } else
          this.$router.replace({
            path: bookmark.entityLink,
            params: { sid: bookmark.entityId },
            query: {
              sid: bookmark.entityId,
            },
          });
      } else {
        return;
      }
    },
    initiateShare(object) {
      this.isShare = true;
      this.currentBookmark = object;
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          var x = document.getElementsByClassName("v-card__text")[0];
          x.scrollTo(0, 0);
        }, 0);
      });
    },
    closeHandler() {
      this.selected = [];
      this.selectAll = false;
      this.isShare = false;
    },
    shareData() {
      let sharedData = {};
      sharedData.atteendees = this.selected;
      sharedData.selectedBookmark = this.currentBookmark;
      let attendeeIds = [];
      this.selected.forEach((attendee) => {
        attendeeIds.push(attendee.id);
      });
      this.selected = [];
      this.selectAll = false;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          sharedWithUserIds: attendeeIds,
          sharedItems: [this.currentBookmark],
          senderName: this.$store.state.user[0].name,
          senderPhotoUrl: this.$store.state.user[0].profilepic
            ? this.$store.state.user[0].profilepic
            : "",
        },
      };
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Share,
        data: rqstData,
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + this.getSessionToken(),
        },
      })
        .then(() => {
          this.showSnackbar("Briefcase data shared");
        })
        .catch((err) => {
          console.log(err);
        });
      this.isShare = false;
    },
    selectAllClicked() {
      if (this.selectAll) {
        let selectedCheck = [];
        for (var i = 0; i < 5; i++) {
          selectedCheck.push(this.attendeeList[i]);
        }
        this.selected = selectedCheck;
      } else {
        this.selected = [];
      }
    },
    getInitials(name) {
      return common.getInitials(name);
    },
    fetchAllAttendees() {
      var obj = this.$store.state;
      var loggedInUserId = obj.user[0].id;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
      };
      let keys = {
        instanceId: "OA_UAT",
        clientId: obj.client[0].id,
        eventId: obj.eventid,
      };
      this.attendeeList = [];
      let rqstData = {
        key: keys,
        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "WEB",
        },
      };
      axios
        .post(this.APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          responseData.data.result.map((attendee) => {
            if (loggedInUserId != attendee.AttendeeId) {
              this.attendeeList.push({
                title: attendee.Name,
                id: attendee.AttendeeId,
                ProfilePictureURL: attendee.ProfilePictureURL,
                checked: false,
              });
              this.originalAttendeeList.push({
                title: attendee.Name,
                id: attendee.AttendeeId,
                ProfilePictureURL: attendee.ProfilePictureURL,
                checked: false,
              });
            }
          });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    deleteBriefcase(object) {
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityId: object.entityId,
        },
      };
      this.briefCaseObjects = this.briefCaseObjects.filter(
        (val) => val.entityId != object.entityId
      );
      this.briefCaseObjectsOriginalthis = this.briefCaseObjectsOriginal.filter(
        (val) => val.entityId != object.entityId
      );
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Delete,
        data: rqstData,
      })
        .then(() => {})
        .catch(() => {});
    },
    filterSelected(selectedFilter) {
      if (selectedFilter.ENTITY_TYPE != 0) {
        this.briefCaseObjects = [
          ...this.briefCaseObjectsOriginal.filter((val) => {
            return val.entityType == selectedFilter.ENTITY_TYPE;
          }),
        ];
      } else this.briefCaseObjects = [...this.briefCaseObjectsOriginal];
    },
    getBriefcaseVals() {
      this.loader = true;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
        },
      };
      this.briefCaseObjects = [];
      this.briefCaseObjectsOriginal = [];
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Get,
        data: rqstData,
      })
        .then((res) => {
          this.loader = false;
          let briefcases = res.data;
          briefcases.forEach((bookmark) => {
            if (bookmark.isPublished) {
              bookmark.shareMenu = false;
              this.briefCaseObjects.push(bookmark);
              this.briefCaseObjectsOriginal.push(bookmark);
            }
          });
        })
        .catch((e) => {
          this.loader = false;
          console.log(e);
        });
    },
  },
};
</script>

<style>
.checkBoxBriefcase > .label {
  margin-bottom: 0px;
}
/* .client-dialog-briefcase .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #cbcbcb;
} */
.tab-active {
  color: #000 !important;
}
.searchField .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #cbcbcb;
}
.client-dialog-briefcase button.filter-butn {
  background: #fff !important;
  box-shadow: none !important;
  border: 1px solid #cbcbcb !important;
}
.exhibit-image .v-image__image--cover {
  background-size: 100%;
}
.single-briefcase-list .v-avatar {
  border: 1px solid #838383;
}
.v-card__text {
  overflow-x: hidden;
}
span.name-initial-wrap {
  height: 80px;
  width: 80px;
  display: inline-flex;
  background: #a3a3a3;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 36px;
  color: #fff;
}
.checkBoxBriefcase .v-messages {
  display: none;
}
.share-people .v-list-item {
  width: 100%;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  margin-bottom: 15px;
  background: #f3f3f3;
}
.checkBoxBriefcase .v-label {
  margin: 0;
}
.checkBoxBriefcase .v-input__slot {
  margin: 0;
}
.single-briefcase-list:first-child {
  padding-top: 15px !important;
}
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .shared-data-people {
    font-size: 18px !important;
  }
  .shared-file-name {
    padding-left: 35px;
  }
}
</style>
